import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import PageTransition from "@/components/feature/PageTransition";
import BottomNav from "@/components/feature/BottomNav";

const BOTTOM_NAV_PATHS = ['/', '/shop', '/cart', '/mine'];

function AppInner() {
  const location = useLocation();
  const showNav = BOTTOM_NAV_PATHS.includes(location.pathname);

  return (
    <>
      <PageTransition>
        <AppRoutes />
      </PageTransition>
      {showNav && <BottomNav />}
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
